<template>
  <div class="admin-knowledge-base-create p-4 sm:p-6 lg:p-8">
    <!-- Header -->
    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6">
      <div>
        <h1 class="text-3xl font-bold text-gray-900">Create Knowledge Base Article</h1>
        <p class="text-gray-600 mt-1">Add a new article to the knowledge base</p>
      </div>
      <Link
        :href="route('admin.knowledge-base.index')"
        class="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors"
      >
        Back to List
      </Link>
    </div>

    <!-- Form -->
    <div class="bg-white rounded-lg shadow-md border border-gray-200 p-6">
      <form @submit.prevent="submit">
        <div class="space-y-6">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">Title *</label>
            <input
              v-model="form.title"
              type="text"
              required
              maxlength="150"
              class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
            />
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">Type *</label>
            <select
              v-model="form.type_id"
              required
              class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
            >
              <option value="">Select a type</option>
              <option v-for="type in types" :key="type.id" :value="type.id">
                {{ type.name }}
              </option>
            </select>
          </div>

          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">Details *</label>
            <textarea
              v-model="form.details"
              required
              rows="10"
              class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-green-500"
            ></textarea>
            <p class="text-xs text-gray-500 mt-1">You can use HTML formatting</p>
          </div>

          <div class="flex items-center gap-4">
            <button
              type="submit"
              :disabled="submitting"
              class="px-6 py-3 bg-green-600 text-white rounded-lg font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed hover:bg-green-700"
            >
              {{ submitting ? 'Creating...' : 'Create Article' }}
            </button>
            <Link
              :href="route('admin.knowledge-base.index')"
              class="px-6 py-3 bg-gray-200 text-gray-700 rounded-lg font-semibold transition-colors hover:bg-gray-300"
            >
              Cancel
            </Link>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Link, router, useForm } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'

export default {
  layout: Layout,
  components: {
    Link,
  },
  props: {
    types: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      default: 'Create Knowledge Base Article',
    },
  },
  data() {
    return {
      form: useForm({
        title: '',
        type_id: '',
        details: '',
      }),
      submitting: false,
    }
  },
  methods: {
    submit() {
      this.submitting = true
      this.form.post(route('admin.knowledge-base.store'), {
        onSuccess: () => {
          if (window.$toast) {
            window.$toast.success('Article created successfully')
          }
          router.visit(route('admin.knowledge-base.index'))
        },
        onError: () => {
          this.submitting = false
        },
        onFinish: () => {
          this.submitting = false
        },
      })
    },
  },
}
</script>

<style scoped>
.admin-knowledge-base-create {
  min-height: 100vh;
  background-color: #f9fafb;
}
</style>



